import { z } from 'zod'
import { ProjectEditorSchema, type ProjectEditor } from '@forgd/shared/schemas/project-editor'

export { ProjectEditorSchema, type ProjectEditor }

export const ProjectEditSchema = z.object({
  isActiveEditor: z.boolean(),
  canRequestEdit: z.boolean(),
  activeEditor: ProjectEditorSchema,
  pendingEditor: ProjectEditorSchema.nullable().default(null),
  autoApproveAt: z.date().nullable(),
  autoApproveIntervalSeconds: z.number(),
})
